<app-form-group>
  <app-info class="formGroupLabel">
    <label>Stevedore company</label>
    <div class="tooltipContent">If you choose "Other" enter the company name in the "Stevedore company details" field</div>
  </app-info>
  <app-select id="stevedoreCompany" [optionsProvider]="fumigationStevedoreCompanies"
              dataKey="name"
              [(ngModel)]="fumigation().stevedoreCompany"
              required></app-select>
</app-form-group>
@if (isOtherStevedoreCompany()) {
  <app-form-group>
    <app-info class="formGroupLabel">
      <label>Stevedore company details</label>
      <div class="tooltipContent">Enter the stevedore company name</div>
    </app-info>
    <textarea id="stevedoreCompanyDetails"
              [(ngModel)]="fumigation().stevedoreCompanyDetails" rows="2" maxlength="256" class="form-control" required>
    </textarea>
  </app-form-group>
}
